var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridLoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "36px",
    viewBox: "0 0 31 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loop-Optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LO-Recent-v2",
    transform: "translate(-442, -745)",
    fill: "#0C1F28",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    transform: "translate(416, 722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(11, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3448943,13.719459 L45.3448943,16.9223104 L36.7658438,16.921459 L37.7088438,20.124459 L45.3448943,20.1251618 L45.3448943,23.3280132 L38.6528438,23.327459 L45.7315315,47.362279 L42.6790183,48.2721717 L40.0998438,39.516459 L20.8748438,39.516459 L18.296357,48.2721717 L15.2438438,47.362279 L22.3218438,23.327459 L15.6304811,23.3280132 L15.6304811,20.1251618 L23.2658438,20.124459 L24.2088438,16.921459 L15.6304811,16.9223104 L15.6304811,13.719459 L45.3448943,13.719459 Z M32.4760151,20.3642114 L27.1738086,28.7979357 L29.8249118,28.7979357 L29.8249118,34.9826668 L35.1271184,26.5489426 L32.4760151,26.5489426 L32.4760151,20.3642114 Z",
    id: "Combined-Shape-Copy-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLoop);
export default __webpack_public_path__ + "static/media/gridLoop.9615ed3b8a7f5409435642ff8f22b0dc.svg";
export { ForwardRef as ReactComponent };